import { ACTION } from './lightingset_actions';
import {
  list_reducer,
  add_reducer,
  update_reducer,
  delete_reducer, add_to_list_reducer, update_in_list_reducer, delete_in_list_reducer,
} from '../reducers';

const initialState = {
  objects: {},
  orderedIds: [],
  totalCount: null,
  filteredCount: null,
  isLoading: false,
  isCreating: false,
  isEditing: false,
  isDeleting: false,
  isDuplicating: false,
  errorMessage: null,
  isLuminaireAdding: false,
  tobeCreatedluminaireRel: [],
  tobeCreatedballastRel: [],
  isLuminaireEditing: false,
  isLuminaireRemoving: false,
  isBallastAdding: false,
  isBallastEditing: false,
  isBallastRemoving: false,

};

export default (state = initialState, action) => {
  const BULB_KEY = 'bulb_list';
  const BALLAST_KEY = 'ballast_list';
  switch (action.type) {
    case `${ACTION.LIST}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.LIST}_FULFILLED`:
      return {
        ...state,
        ...list_reducer(state, action),
        isLoading: false,
      };
    case `${ACTION.LIST}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.GET}_PENDING`:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case `${ACTION.GET}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isLoading: false,
        errorMessage: null,
      };
    case `${ACTION.GET}_REJECTED`:
      return {
        ...state,
        isLoading: false,
        errorMessage: action.payload,
      };
    case `${ACTION.CREATE}_PENDING`:
      return {
        ...state,
        isCreating: true,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isCreating: false,
        errorMessage: null,
      };
    case `${ACTION.CREATE}_REJECTED`:
      return {
        ...state,
        isCreating: false,
        errorMessage: action.payload,
      };
    case `${ACTION.EDIT}_PENDING`:
      return {
        ...state,
        isEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_FULFILLED`:
      return {
        ...state,
        ...update_reducer(state, action),
        isEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT}_REJECTED`:
      return {
        ...state,
        isEditing: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DELETE}_PENDING`:
      return {
        ...state,
        isDeleting: true,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_FULFILLED`:
      return {
        ...state,
        ...delete_reducer(state, action),
        isDeleting: false,
        errorMessage: null,
      };
    case `${ACTION.DELETE}_REJECTED`:
      return {
        ...state,
        isDeleting: false,
        errorMessage: action.payload,
      };
    case `${ACTION.DUPLICATE}_PENDING`:
      return {
        ...state,
        isDuplicating: true,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_FULFILLED`:
      return {
        ...state,
        ...add_reducer(state, action),
        isDuplicating: false,
        errorMessage: null,
      };
    case `${ACTION.DUPLICATE}_REJECTED`:
      return {
        ...state,
        isDuplicating: false,
        errorMessage: action.payload,
      };

    case `${ACTION.ADD_LUMINAIRE}_PENDING`:
      return {
        ...state,
        isLuminaireAdding: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_LUMINAIRE}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.lighting_set_id, action.payload, BULB_KEY),
        isLuminaireAdding: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_LUMINAIRE}_REJECTED`:
      return {
        ...state,
        isLuminaireAdding: false,
        errorMessage: action.payload,
      };

    case `${ACTION.EDIT_LUMINAIRE}_PENDING`:
      return {
        ...state,
        isLuminaireEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT_LUMINAIRE}_FULFILLED`:
      return {
        ...state,
        ...update_in_list_reducer(state, action.payload.lighting_set_id, action.payload, BULB_KEY),
        isLuminaireEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT_LUMINAIRE}_REJECTED`:
      return {
        ...state,
        isLuminaireEditing: false,
        errorMessage: action.payload,
      };

    case `${ACTION.REMOVE_LUMINAIRE}_PENDING`:
      return {
        ...state,
        isLuminaireRemoving: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_LUMINAIRE}_FULFILLED`:
      return {
        ...state,
        ...delete_in_list_reducer(state, action.payload.lighting_set_id, action.payload.id, BULB_KEY),
        isLuminaireRemoving: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_LUMINAIRE}_REJECTED`:
      return {
        ...state,
        isLuminaireRemoving: false,
        errorMessage: action.payload,
      };

    case `${ACTION.ADD_BALLAST}_PENDING`:
      return {
        ...state,
        isBallastAdding: true,
        errorMessage: null,
      };
    case `${ACTION.ADD_BALLAST}_FULFILLED`:
      return {
        ...state,
        ...add_to_list_reducer(state, action.payload.lighting_set_id, action.payload, BALLAST_KEY),
        isBallastAdding: false,
        errorMessage: null,
      };
    case `${ACTION.ADD_BALLAST}_REJECTED`:
      return {
        ...state,
        isBallastAdding: false,
        errorMessage: action.payload,
      };

    case `${ACTION.EDIT_BALLAST}_PENDING`:
      return {
        ...state,
        isBallastEditing: true,
        errorMessage: null,
      };
    case `${ACTION.EDIT_BALLAST}_FULFILLED`:
      return {
        ...state,
        ...update_in_list_reducer(state, action.payload.lighting_set_id, action.payload, BALLAST_KEY),
        isBallastEditing: false,
        errorMessage: null,
      };
    case `${ACTION.EDIT_BALLAST}_REJECTED`:
      return {
        ...state,
        isBallastEditing: false,
        errorMessage: action.payload,
      };

    case `${ACTION.REMOVE_BALLAST}_PENDING`:
      return {
        ...state,
        isBallastRemoving: true,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_BALLAST}_FULFILLED`:
      return {
        ...state,
        ...delete_in_list_reducer(state, action.payload.lighting_set_id, action.payload.id, BALLAST_KEY),
        isBallastRemoving: false,
        errorMessage: null,
      };
    case `${ACTION.REMOVE_BALLAST}_REJECTED`:
      return {
        ...state,
        isBallastRemoving: false,
        errorMessage: action.payload,
      };

    case ACTION.CLEAR_ERROR:
      return {
        ...state,
        errorMessage: null,
      };
    case `${ACTION.ADD_LUMINAIRE_TOBECREATED}_FULFILLED`:
      return {
        ...state,
        tobeCreatedluminaireRel: [...state.tobeCreatedluminaireRel, action.payload],
        errorMessage: null,
      }
    case `${ACTION.ADD_LUMINAIRE_TOBECREATED}_REJECTED`:
      return {
        ...state,
        isLuminaireAdding: false,
        errorMessage: action.payload
      }
    case `${ACTION.ADD_BALLAST_TOBECREATED}_FULFILLED`:
      return {
        ...state,
        tobeCreatedballastRel: [...state.tobeCreatedballastRel, action.payload],
        errorMessage: null,
      }
    case `${ACTION.ADD_BALLAST_TOBECREATED}_REJECTED`:
      return {
        ...state,
        isBallastAdding: false,
        errorMessage: action.payload
      }
    case `${ACTION.EDIT_BALLAST_TOBECREATED}_PENDING`:
      return {
        ...state,
        isBallastEditing: true,
      };
    case `${ACTION.EDIT_BALLAST_TOBECREATED}_FULFILLED`:
      return {
        ...state,
        tobeCreatedballastRel: state.tobeCreatedballastRel.map(
          rel => rel.ballast.id === action.payload.id ? {...rel, quantity: action.payload.quantity} : rel
        ),
        isBallastEditing: false,
      };
    case `${ACTION.EDIT_LUMINAIRE_TOBECREATED}_PENDING`:
      return {
        ...state,
        isLuminaireEditing: true,
      };
    case `${ACTION.EDIT_LUMINAIRE_TOBECREATED}_FULFILLED`:

      return {
        ...state,
        tobeCreatedluminaireRel: state.tobeCreatedluminaireRel.map(
          rel => rel.bulb.id === action.payload.id ? {...rel, quantity: action.payload.quantity} : rel
        ),
        isLuminaireEditing: false,
      };
    case `${ACTION.REMOVE_BALLAST_TOBECREATED}_PENDING`:
      return {
        ...state,
        isBallastRemoving: true,
      };
    case `${ACTION.REMOVE_BALLAST_TOBECREATED}_FULFILLED`:

      return {
        ...state,
        tobeCreatedballastRel: state.tobeCreatedballastRel.filter(rel => rel.ballast.id !== action.payload.id),
        isBallastRemoving: false,
      };
    case `${ACTION.REMOVE_LUMINAIRE_TOBECREATED}_PENDING`:
      return {
        ...state,
        isLuminaireRemoving: true,
      };
    case `${ACTION.REMOVE_LUMINAIRE_TOBECREATED}_FULFILLED`:

      return {
        ...state,
        tobeCreatedluminaireRel: state.tobeCreatedluminaireRel.filter(rel => rel.bulb.id !== action.payload.id),
        isLuminaireRemoving: false,
      };
    case `${ACTION.CLEAR_LIGHTING_SET}_FULFILLED`:
    return {
      ...state,
      tobeCreatedluminaireRel: [],
      tobeCreatedballastRel: [],
    };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/luminaire/lightingset_reducer.js